require('./_set-species')('Array');


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es6.array.species.js
// module id = ./node_modules/core-js/modules/es6.array.species.js
// module chunks = 2